import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["target", "template"]

    add(event) {
        event.preventDefault()

        const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
        this.targetTarget.insertAdjacentHTML('beforeend', content)
    }

    remove(event) {
        event.preventDefault()

        const wrapper = event.target.closest('.nested-form-wrapper')
        if (wrapper.dataset.newRecord === "true") {
            wrapper.remove()
        } else {
            wrapper.style.display = 'none'
            wrapper.querySelector("input[name*='_destroy']").value = 1
        }
    }

    // 配列形式（checklist[]）用の削除処理
    removeField(event) {
        event.preventDefault()
        const wrapper = event.target.closest('.nested-form-wrapper')
        wrapper.remove()
    }
}
